export const ContactSpecialist = (fullFormState, coverageAmount, termLength, healthClass, quoteResults, redirect, onMultiFieldChange, isAmerico) => {
  const form = {...fullFormState};
  form.pages.quoter.isSelectOrTalk = "contactSpecialist";
  form.pages.quoter.coverageAmount = coverageAmount;
  if (isAmerico) {
    form.steps.quoter.coverageAmount = coverageAmount;
    form.steps.quoter.term = termLength;
  }
  form.pages.quoter.termLength = termLength;
  form.pages.quoter.healthClass = healthClass;
  form.pages.quoter.premium = (quoteResults && quoteResults.length > 0 && quoteResults[0].monthlyRate) || null;
  onMultiFieldChange(form);
  redirect();
}



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/Common/ContactSpecialist.js